// src/components/PageShell.js
// Wrapper commun pour toutes les pages.

import { C, FONTS } from '../styles/theme';

export function PageShell({ children, style = {} }) {
  return (
    <div style={{ background: C.bg, minHeight: '100vh', padding: '52px 20px 90px', ...style }}>
      {children}
    </div>
  );
}

export function PageTitle({ children }) {
  return (
    <h1 style={{ fontFamily: FONTS.display, fontSize: 28, color: C.text, fontStyle: 'italic', marginBottom: 28 }}>
      {children}
    </h1>
  );
}

export function Divider({ style = {} }) {
  return <div style={{ height: 1, background: '#DDD3C4', margin: '20px 0', ...style }}/>;
}

export function SectionLabel({ children }) {
  return (
    <div style={{ fontSize: 11, fontWeight: '600', letterSpacing: '0.1em', color: '#B09880', textTransform: 'uppercase', marginBottom: 12 }}>
      {children}
    </div>
  );
}

export function SectionHead({ icon, title }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
      <span style={{ fontSize: 20 }}>{icon}</span>
      <span style={{ fontWeight: '600', fontSize: 15, color: '#3D2E24' }}>{title}</span>
    </div>
  );
}
